(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rp-offer-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.rpReady === 'true') return;
      root.dataset.rpReady = 'true';
      const cards = [...root.querySelectorAll('.rp-card')];
      const summary = root.querySelector('[data-summary]');
      const totalPrice = root.querySelector('[data-total]');
      const status = root.querySelector('[data-status]');
      const addButton = root.querySelector('[data-add]');
      if (!cards.length || !summary || !totalPrice || !status || !addButton) return;
      const prices = root.dataset.offerPrices.split(',').map(Number);
      const formatter = new Intl.NumberFormat(root.dataset.locale, {
        style: 'currency',
        currency: root.dataset.currency
      });
      const quantity = () => cards.reduce((sum, card) => sum + Number(card.dataset.qty || 0), 0);
      const draw = () => {
        const count = quantity();
        cards.forEach((card) => {
          const cardQuantity = Number(card.dataset.qty || 0);
          card.querySelector('[data-count]').textContent = String(cardQuantity);
          card.classList.toggle('is-selected', cardQuantity > 0);
          card.querySelector('[data-minus]').disabled = cardQuantity === 0;
          card.querySelector('[data-plus]').disabled = count >= 3;
        });
        if (count === 0) summary.textContent = root.dataset.summaryEmpty;
        if (count === 1) summary.textContent = root.dataset.summaryOne;
        if (count > 1) summary.textContent = root.dataset.summaryMany.replace('__count__', String(count));
        totalPrice.textContent = count ? `${root.dataset.totalLabel} ${formatter.format(prices[count] / 100)}` : '';
        status.textContent = count === 3 ? root.dataset.statusComplete : root.dataset.statusMax;
        addButton.disabled = count < 1 || count > 3;
      };
      cards.forEach((card) => {
        card.querySelector('[data-plus]').addEventListener('click', () => {
          if (quantity() < 3) card.dataset.qty = String(Number(card.dataset.qty || 0) + 1);
          draw();
        });
        card.querySelector('[data-minus]').addEventListener('click', () => {
          if (Number(card.dataset.qty || 0) > 0) card.dataset.qty = String(Number(card.dataset.qty) - 1);
          draw();
        });
      });
      addButton.addEventListener('click', async () => {
        const items = cards
          .filter((card) => Number(card.dataset.qty) > 0)
          .map((card) => ({ id: card.dataset.variantId, quantity: Number(card.dataset.qty) }));
        if (!items.length) return;
        addButton.disabled = true;
        addButton.textContent = root.dataset.addingLabel;
        try {
          const response = await fetch(`${root.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          status.textContent = root.dataset.error;
          addButton.textContent = root.dataset.addLabel;
          addButton.disabled = false;
        }
      });
      draw();
    };
    const initAll = (scope) => {
      if (scope.matches && scope.matches('[data-rp-selector]')) init(scope);
      scope.querySelectorAll('[data-rp-selector]').forEach(init);
    };
    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zanoma-offer-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.rpReady === 'true') return;
      root.dataset.rpReady = 'true';
      const cards = [...root.querySelectorAll('.rp-card')];
      const summary = root.querySelector('[data-summary]');
      const totalPrice = root.querySelector('[data-total]');
      const status = root.querySelector('[data-status]');
      const addButton = root.querySelector('[data-add]');
      if (!cards.length || !summary || !totalPrice || !status || !addButton) return;
      const prices = root.dataset.offerPrices.split(',').map(Number);
      const formatter = new Intl.NumberFormat(root.dataset.locale, {
        style: 'currency',
        currency: root.dataset.currency
      });
      const quantity = () => cards.reduce((sum, card) => sum + Number(card.dataset.qty || 0), 0);
      const draw = () => {
        const count = quantity();
        cards.forEach((card) => {
          const cardQuantity = Number(card.dataset.qty || 0);
          card.querySelector('[data-count]').textContent = String(cardQuantity);
          card.classList.toggle('is-selected', cardQuantity > 0);
          card.querySelector('[data-minus]').disabled = cardQuantity === 0;
          card.querySelector('[data-plus]').disabled = count >= 3;
        });
        if (count === 0) summary.textContent = root.dataset.summaryEmpty;
        if (count === 1) summary.textContent = root.dataset.summaryOne;
        if (count > 1) summary.textContent = root.dataset.summaryMany.replace('__count__', String(count));
        totalPrice.textContent = count ? `${root.dataset.totalLabel} ${formatter.format(prices[count] / 100)}` : '';
        status.textContent = count === 3 ? root.dataset.statusComplete : root.dataset.statusMax;
        addButton.disabled = count < 1 || count > 3;
      };
      cards.forEach((card) => {
        card.querySelector('[data-plus]').addEventListener('click', () => {
          if (quantity() < 3) card.dataset.qty = String(Number(card.dataset.qty || 0) + 1);
          draw();
        });
        card.querySelector('[data-minus]').addEventListener('click', () => {
          if (Number(card.dataset.qty || 0) > 0) card.dataset.qty = String(Number(card.dataset.qty) - 1);
          draw();
        });
      });
      addButton.addEventListener('click', async () => {
        const items = cards
          .filter((card) => Number(card.dataset.qty) > 0)
          .map((card) => ({ id: card.dataset.variantId, quantity: Number(card.dataset.qty) }));
        if (!items.length) return;
        addButton.disabled = true;
        addButton.textContent = root.dataset.addingLabel;
        try {
          const response = await fetch(`${root.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          status.textContent = root.dataset.error;
          addButton.textContent = root.dataset.addLabel;
          addButton.disabled = false;
        }
      });
      draw();
    };
    const initAll = (scope) => {
      if (scope.matches && scope.matches('[data-rp-selector]')) init(scope);
      scope.querySelectorAll('[data-rp-selector]').forEach(init);
    };
    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
